export default __webpack_public_path__ + "static/media/026-dinosaur.69f761df.svg";